"use strict";
/**
 * 前端站点地区检测
 *
 * 检测优先级：
 * 1. 从 Fego 系统注入的 window 变量获取（TODO：等 Fego 侧吐出后接入）
 * 2. 从当前页面 URL 兜底推断
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_LOCATION_HEADER = void 0;
exports.getSiteLocation = getSiteLocation;
exports._resetForTesting = _resetForTesting;
const utils_1 = require("@ark/utils");
/** 站点地区请求头名称 */
exports.SITE_LOCATION_HEADER = 'x-activity-site-location';
const KNOWN_LOCATIONS = new Set(Object.values(utils_1.BusinessLocation));
/**
 * 香港特殊域名后缀
 * 匹配规则：hostname === suffix 或 hostname 以 .suffix 结尾
 * 例如 futuhk.com、www.futuhk.com、invest.futuhk.com、www-origin.futuhk.com 都命中
 */
const HK_DOMAIN_SUFFIXES = [
    'futuhk.com',
    'futuhk1.com',
    'futuhk2.com',
    'futufin.com',
    'futuhongkong.com',
    'futuhn.com',
    'futunh.com',
    'futuhk8.com',
    'futuhkapp.com',
];
/**
 * 匹配 {prefix}[.|-]{region}.{moomoo系列}.com
 * prefix：invest、fego 等子站前缀
 * 分隔符：点号或连字符
 * 例如：invest.jp.moomoo.com、invest-jp.moomoo.com、fego-au.moomoo.com、fego.au.moomoo.com
 */
const SUBDOMAIN_MOOMOO_PATTERN = /^(?:invest|fego)[.-](\w+)\.(moomoo|moomooapp|moomoobull|moomoocn)\.com$/;
/**
 * moomoo 系列 www 域名，从 pathname 第一段提取地区
 * 路径格式：/{region}/events、/{region}/campaigns、/{region}/promotion 等
 */
const MOOMOO_WWW_DOMAINS = new Set([
    'www.moomoo.com',
    'www.moomooapp.com',
    'www.moomoobull.com',
    'www.moomoocn.com',
]);
function isHKDomain(hostname) {
    return HK_DOMAIN_SUFFIXES.some((suffix) => hostname === suffix || hostname.endsWith(`.${suffix}`));
}
/**
 * 将字符串转为 BusinessLocation 枚举值，无效时返回 undefined
 */
function toBusinessLocation(value) {
    const upper = value.toUpperCase();
    if (KNOWN_LOCATIONS.has(upper))
        return upper;
    return undefined;
}
/**
 * 从 Fego 系统注入的 window 变量获取地区
 */
function detectFromFegoVariable() {
    // TODO: 等 Fego 系统吐出地区变量后，从 window 上读取
    // 预期用法（具体变量路径待 Fego 侧确认）：
    // const fegoLocation = (window as any)?.FEGORender?.env?.siteLocation;
    // return toBusinessLocation(fegoLocation);
    return undefined;
}
/**
 * 从当前 URL 兜底推断地区
 *
 * 匹配规则：
 * 1. 香港特殊域名后缀（futuhk 系列，任意前缀）→ HK
 * 2. {prefix}[.|-]{region}.{moomoo系列}.com → 提取 region（prefix 为 invest、fego 等）
 * 3. www.{moomoo系列}.com/{region}/... → 提取 pathname 第一段作为 region
 */
function detectFromURL() {
    if (typeof window === 'undefined')
        return undefined;
    const { hostname, pathname } = window.location;
    if (isHKDomain(hostname))
        return utils_1.BusinessLocation.HK;
    const subdomainMatch = hostname.match(SUBDOMAIN_MOOMOO_PATTERN);
    if (subdomainMatch) {
        return toBusinessLocation(subdomainMatch[1]);
    }
    if (MOOMOO_WWW_DOMAINS.has(hostname)) {
        const pathMatch = pathname.match(/^\/([a-z]{2})\//i);
        if (pathMatch) {
            return toBusinessLocation(pathMatch[1]);
        }
    }
    return undefined;
}
let cachedLocation;
let detected = false;
/**
 * 获取当前站点地区
 *
 * 优先从 Fego 系统变量获取，获取不到则从 URL 兜底推断。
 * 结果会缓存，多次调用不会重复计算。
 *
 * @returns BusinessLocation 枚举值，无法识别时返回 undefined
 */
function getSiteLocation() {
    if (detected)
        return cachedLocation;
    cachedLocation = detectFromFegoVariable() ?? detectFromURL();
    detected = true;
    return cachedLocation;
}
/**
 * 重置缓存（仅用于测试）
 */
function _resetForTesting() {
    cachedLocation = undefined;
    detected = false;
}
